import { VideoBannerType } from "@/common/lib/types";
import { CLink } from "../common/customLink/CustomLink";
import VideoCard from "../common/videoCard/VideoCard";
import { languages } from "@/i18n/routing";
import { getLangFromLocale } from "@/utils/common";

interface IProps {
  content: VideoBannerType;
  locale: string;
}
const PlpVideoBannerView = ({ content, locale }: IProps) => {
  const { video } = content;
  const lang = getLangFromLocale(locale);
  const isLargeVideo = content?.bannerType === "largeVideo";
  return (
    <div>
      {/* mobie view */}
      <div className="md:hidden">
        <VideoCard
          showControls={video?.showControls}
          url={video.link?.url}
          containerProps={{
            style: {
              width: "375",
              height: isLargeVideo ? "597" : "375",
            },
          }}
          videoProps={{
            src: lang === "en" ? video?.en : video.ar,
            className: "h-full w-full object-cover",
            // autoPlay: true,
            muted: true,
            loop: video?.loop,
            poster: lang === "en" ? video.fallbackImage?.en : video?.fallbackImage?.ar,
            style: {
              // height: isLargeVideo ? "597px" : "375px",
              aspectRatio: isLargeVideo ? "0.63/1" : "1/1",

            }
          }}
        />
      </div>

      {/* desktop view */}
      <div className="hidden md:block">
        <VideoCard
          showControls={video?.showControls}
          url={video.link?.url}
          containerProps={{
            style: {
              width: isLargeVideo ? "1440" : "1920",
              height: isLargeVideo ? "654" : "387",
            },
          }}
          videoProps={{
            src: lang === "en" ? video.en : video.ar,
            className: "h-full w-full object-cover",
            // autoPlay: true,
            muted: true,
            loop: video?.loop,
            poster: lang === "en" ? video.fallbackImage?.en : video?.fallbackImage?.ar,
            style: {
              // height: isLargeVideo ? "654px" : "387px",
              aspectRatio: isLargeVideo ? "2.2/1" : "4.96/1",


            }
          }}
        />
      </div>
    </div>
  );
};

export default PlpVideoBannerView;
